/**
 * MIME allowlist for manual ticket uploads (create + sidebar upload).
 * Mirrors `Attachment::ACCEPTABLE_FILE_TYPES` + `media_file?` in app/models/attachment.rb.
 * Update both places when extending supported types.
 */
const EXTRA_MIME_TYPES = Object.freeze([
  'text/csv',
  'text/plain',
  'text/rtf',
  'application/json',
  'application/pdf',
  'application/zip',
  'application/x-7z-compressed',
  'application/vnd.rar',
  'application/x-tar',
  'application/msword',
  'application/vnd.ms-excel',
  'application/vnd.ms-powerpoint',
  'application/rtf',
  'application/vnd.oasis.opendocument.text',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
]);

const EXTRA_SET = new Set(EXTRA_MIME_TYPES);

/**
 * @param {string} contentType
 * @returns {boolean}
 */
export function isTicketAttachmentMimeAllowed(contentType) {
  if (!contentType || typeof contentType !== 'string') return false;
  const ct = contentType.toLowerCase().trim();
  if (
    ct.startsWith('image/') ||
    ct.startsWith('video/') ||
    ct.startsWith('audio/')
  ) {
    return true;
  }
  return EXTRA_SET.has(ct);
}
